import { Button, Select } from '@trackman/web-shared-components';

import { AdminTourAveragesUnits, NewTourParameterData, TourAverageParameterOption } from 'types/admin/tourAverages';
import { Input } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { unitNamesMapper } from 'utilities/unitNamesMapper';

type Props = {
  availableParameters: TourAverageParameterOption[];
  year: number | null;
  newTourParameterData: NewTourParameterData;
  onYearChange: (year: number) => void;
  onNewParameterSelected: (parameterId: string) => void;
  onNewParameterUnitChanged: (unit: AdminTourAveragesUnits) => void;
  onAddParameter: () => void;
};

export const TourAveragesTableToolbar = ({
  availableParameters,
  year,
  newTourParameterData,
  onYearChange,
  onNewParameterSelected,
  onNewParameterUnitChanged,
  onAddParameter,
}: Props) => {
  return (
    <div className='admin-edit-section table-toolbar'>
      <div className='input-container year-input'>
        <Paragraph>
          <>Year of data collected:</>
        </Paragraph>
        <Input
          type='number'
          label='Year'
          value={year ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onYearChange(Number(e.currentTarget.value))}
        />
      </div>
      {availableParameters.length ? (
        <>
          <div className='inputs-wrapper'>
            <div className='input-container'>
              <Select
                label='Parameter name'
                value={newTourParameterData.parameterId ?? ''}
                onChange={(event) => onNewParameterSelected(event.target.value as string)}
                selectOptions={availableParameters.map((parameter) => {
                  return {
                    label: `${parameter.title} (${parameter.categoryLabel})`,
                    value: parameter.id,
                  };
                })}
              />
            </div>
            <div className='input-container'>
              <Select
                label='Parameter unit'
                disabled={newTourParameterData.parameterId === ''}
                value={newTourParameterData?.unit ?? ''}
                onChange={(event) => onNewParameterUnitChanged(event.target.value as AdminTourAveragesUnits)}
                selectOptions={Object.values(AdminTourAveragesUnits)
                  .filter((unit) => unit !== '')
                  .map((unit) => {
                    return {
                      label: unitNamesMapper(unit),
                      value: unit,
                    };
                  })}
              />
            </div>
          </div>
          <Button className='styled-button primary' disabled={newTourParameterData.parameterId === ''} onClick={onAddParameter}>
            Add new PGA parameter
          </Button>
        </>
      ) : (
        <Paragraph>
          <>All parameters are added</>
        </Paragraph>
      )}
    </div>
  );
};

export default TourAveragesTableToolbar;
